import { useEffect, useRef, useState } from 'react';
import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import './Consulta.css';
import { Panel } from 'primereact/panel';
import { Dropdown } from 'primereact/dropdown';
import FiltroPF from './filtro/FiltroPF';
import FiltroPJ from './filtro/FiltroPJ';
import { FilterWeb } from '../../interface/FilterWeb';
import postConsultaWebService from '../../service/postConsultaWeb/postConsultaWebService';
import Resposta from './Resposta';
import getCache from '../../service/getCache';
import {useNavigate } from 'react-router';
import { Messages } from 'primereact/messages';
import getUserCheck from '../../service/getUserCheck';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';

export default function ConsultaPage() {
  const {state} = useGlobalState();
  const { t } = useTranslation();
  const [resposta, setResposta] = useState<any | null>(null);
  const [original, setOriginal] = useState<boolean>(true);
  const navigate = useNavigate();
  const initialized = useRef(false)
  const msgs = useRef<Messages>(null);


  const processResposta = (data:any, cache:boolean) => {
    if(data.separarResposta){
            
      if(data.scpc || 
        data.restricaoAvancadaScore || 
        data.restricaoSilver || 
        data.restricaoPalladium ||
        data.pendencia ||
        data.protestoCentroProt || 
        data.gps894 ||
        data.gps895 ||
        data.sintegra ||
        data.cadastralSrcBacenScorePositivo ||
        data.srcSintetico ||
        data.srcBacenScorePositivo ||
        data.dividaAtiva ||
        data.pendenciaLN ||
        data.instituicaoPagamento ||
        data.acoesCompleta ||
        data.serasaRelatorioPf ||
        data.serasaRelatorioPj ||
        data.protestoNacionalCpf ||
        data.protestoNacionalCnpj ||
        data.creditoCompletoScore ||
        data.creditoBasicoPlus ||
        data.protestoCartorio ||
        data.protestoCartorioRegional ||
        data.scrSeletor ||
        data.pgfn
      ){
        const respostaInfo = {
          scpc: data.scpc,
          restricaoAvancadaScore: data.restricaoAvancadaScore,
          restricaoSilver: data.restricaoSilver,
          informativo: data.informativo,
          restricaoPalladium : data.restricaoPalladium,
          pendencia: data.pendencia,
          protestoCentroProt: data.protestoCentroProt,
          gps894: data.gps894,
          gps895: data.gps895,
          instituicaoPagamentoSintetico: data.instituicaoPagamentoSintetico,
          laranjaChavePix: data.laranjaChavePix,
          sintegra: data.sintegra,
          cadastralSrcBacenScorePositivo : data.cadastralSrcBacenScorePositivo,
          srcSintetico: data.srcSintetico,
          srcBacenScorePositivo: data.srcBacenScorePositivo,
          dividaAtiva:data.dividaAtiva,
          pendenciaLN:data.pendenciaLN,
          instituicaoPagamento:data.instituicaoPagamento,
          acoesCompleta:data.acoesCompleta,
          pgfn:data.pgfn,
          gps:data.gps,
          creditoPositivo: data.creditoPositivo,
          pendenciaMercado: data.pendenciaMercado,
          pendenciaCompany: data.pendenciaCompany,
          serasaRelatorioPf: data.serasaRelatorioPf,
          serasaRelatorioPj: data.serasaRelatorioPj,
          restricaoFullPf: data.restricaoFullPf,
          restricaoFullPj: data.restricaoFullPj,
          protestoNacionalCpf: data.protestoNacionalCpf,
          protestoNacionalCnpj: data.protestoNacionalCnpj,
          creditoCompletoScore: data.creditoCompletoScore,
          creditoBasicoPlus: data.creditoBasicoPlus,
          protestoCartorio: data.protestoCartorio,
          protestoCartorioRegional: data.protestoCartorioRegional,
          scrSeletor: data.scrSeletor,
          avisos: data.avisos
        }
        localStorage.setItem('respostaInfo', JSON.stringify(respostaInfo));
        data.scpc = null;
        data.restricaoAvancadaScore = null;
        data.restricaoSilver = null;
        data.restricaoPalladium = null;
        data.pendencia = null;
        data.protestoCentroProt = null;
        data.gps894 = null;
        data.gps895 = null;
        data.instituicaoPagamentoSintetico = null;
        data.laranjaChavePix = null;
        data.sintegra = null;
        data.cadastralSrcBacenScorePositivo = null;
        data.srcSintetico = null;
        data.srcBacenScorePositivo = null;
        data.dividaAtiva = null;
        data.pendenciaLN = null;
        data.instituicaoPagamento = null;
        data.acoesCompleta = null;
        data.pgfn = null;
        data.gps = null;
        data.creditoPositivo = null;
        data.pendenciaMercado = null;
        data.pendenciaCompany = null;
        data.serasaRelatorioPf = null;
        data.serasaRelatorioPj = null;
        data.restricaoFullPf = null;
        data.restricaoFullPj = null;
        data.protestoNacionalCpf = null;
        data.protestoNacionalCnpj = null;
        data.creditoCompletoScore = null;
        data.creditoBasicoPlus = null;
        data.protestoCartorio = null;
        data.protestoCartorioRegional = null;
        data.scrSeletor = null;
        if(cache){
          window.open('./info','_blank')
        }
        else{
          window.open('consultar/info','_blank')
        }
        
      }
      if(data.dadosConsulta || 
        data.dadosConsultaPJ || 
        data.score ||
        data.scoreBoletoPJ ||
        data.acoes ||
        data.showApontamento || 
        (data.protestosQuod && data.protestosQuod.length > 0) ||
        (data.ccfs && data.ccfs.length > 0) ||
        data.rendaPresumida ||
        data.scoreGrauAtividadePJ ||
        data.comportamentoFinanceiro ||
        data.gastoEstimadoPJ ||
        data.linhaCredito ||
        data.pontualidadePagamento ||
        data.historicoPagamento ||
        (data.endividamentos && data.endividamentos.length > 0) ||
        data.historicoVencido ||
        data.limiteCreditoPJ ||
        data.maisNegocio ||
        data.faturamentosPresumido ||
        data.consulta ||
        data.scoreInadimplenciaPJ ||
        (data.empresas && data.empresas.length > 0) ||
        (data.socios && data.socios.length > 0) ||
        (data.participacoesEmpresa && data.participacoesEmpresa.length > 0) ||
        (data.enderecosHist && data.enderecosHist.length > 0) ||
        (data.emailsHist && data.emailsHist.length > 0) ||
        (data.conglomerados && data.conglomerados.length > 0) ||
        (data.calularesHist && data.calularesHist.length > 0) ||
        (data.telefonesHist && data.telefonesHist.length > 0) ||
        (data.analises && data.analises.length > 0) ||
        (data.indicadoresPJ && data.indicadoresPJ.length > 0) ||
        (data.indicadores && data.indicadores.length > 0)
        ){
        localStorage.setItem('resposta', JSON.stringify(data));
        if(cache){
          window.open('./quod','_blank')
        }
        else{
          window.open('consultar/quod','_blank')
        }
      }
    }
    else{
      setResposta(data);
    }
  }
  
  const handleCloseFilter = () => {
    setselectedTipoConsulta('pf');
    setResposta(null);
    navigate('/consultar')
  }

  const validIndicadores = (filterWeb:FilterWeb) : boolean => {
    let retorno = true;
    if(filterWeb.indicadores.length != 0){
      filterWeb.indicadores.map((item) => {
        if(item.target.length === 0){
            retorno= false;
        }
      })

    }
    return retorno;
  }

  const handleProcessFilter = (filterWeb:FilterWeb) => {
    msgs.current?.clear();
    if(filterWeb.consultas.length > 0 && (filterWeb.consultas.includes('QUODVERIFIQPJ_MAISNEGOCIO') || filterWeb.consultas.includes('QUODVERIFIQPJ_MAISNEGOCIO_EP') || filterWeb.consultas.includes('QUODMAISNEGOCIOPJ')) && ((!filterWeb.arrojado && !filterWeb.usual && !filterWeb.conservador)  )){
      window.scrollTo(0, 0);
      msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'O perfil de risco são obrigatórios', closable: false }
          
        ]);
    }
    else{
      if(!validIndicadores(filterWeb)){
        window.scrollTo(0, 0);
        msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Indicadores não Selecionados', closable: false }
            
          ]);

      }
      else{
        if(filterWeb.documento && filterWeb.consultas && filterWeb.consultas.length > 0){
          if(filterWeb.indicadores){
            const indicadores :any[] = []
            filterWeb.indicadores.map((item:any) => {item.target.map((i:any) => indicadores.push(i.value))})
            filterWeb.indicadores = indicadores;
          }
          const findLabel = (consultas: Array<any>, value: string): string => {
            for (const consulta of consultas) {
                if (consulta.value === value) {
                    return consulta.label;
                }
                if (consulta.permissoes && consulta.permissoes.length > 0) {
                    const foundLabel = findLabel(consulta.permissoes, value);
                    if (foundLabel !== value) {
                        return foundLabel;
                    }
                }
            }
            return value;
        };
        
       
          postConsultaWebService(filterWeb)
          .then((data) => {
            window.scrollTo(0, 0);
            processResposta(data, false);
            setselectedTipoConsulta('pf');
          })
          .catch((error) => {
            const dataError = String(error)
            window.scrollTo(0, 0);
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Erro ao realizar consulta' + (dataError.startsWith('Error: Cliente') ? (' - ' + dataError.split('Error:')[1]) : ''), closable: false }
              
            ]);
          })
        }
        else{
          window.scrollTo(0, 0);
          msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Documento e opção de consulta são obrigatórios', closable: false }
              
            ]);
        }
      }
    }
    
    
           
    
  }
  const [selectedTipoConsulta, setselectedTipoConsulta] = useState('pf');
    const tiposConsulta = [
        { name: 'Selecione', code: null },
        { name: 'Consulta Pessoa Física', code: 'pf' },
        { name: 'Consulta Pessoa Jurídica', code: 'pj' }
    ];

    const findCacheById = (id:string) => {
      if(id && !id.includes('consultar') && !id.includes('quod') && !id.includes('info')){ 
        getCache(id).then((data:any) => {window.scrollTo(0, 0);
          processResposta(data, true);
        });
      }
    }
   

    useEffect(() => {
      getUserCheck().then((response) => console.log(response))
      if (!initialized.current) {
        initialized.current = true
        const path = window.location.href.split('/')[window.location.href.split('/').length-1];
        if(path === 'info'){
          const resp = localStorage.getItem('respostaInfo')
          if(resp){
            localStorage.removeItem('respostaInfo')
            setOriginal(false)
            setResposta(JSON.parse(resp))
          }
        }
        else{
          const resp = localStorage.getItem('resposta')
          if(resp){
            localStorage.removeItem('resposta')
            setOriginal(false)
            setResposta(JSON.parse(resp))
          }
        }
        findCacheById(path);
      }
    },[])
  
  
  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray">
                <i className="pi pi-search-plus" style={{ fontSize: '2.0rem' }}></i> 
                  {t('consultaCredito')}
                </h1>
            </div>     
          </div>
      </div>
      
      <div className="row">
        <div className='col-lg-6 mb-3' style={{width:'60%'}}>
          <Messages ref={msgs} />
          {resposta == null && (
            <Panel header={t('opcaoConsulta')}>
              <Dropdown value={selectedTipoConsulta} onChange={(e) => setselectedTipoConsulta(e.value)} options={tiposConsulta} optionLabel="name" 
                    placeholder="Selecione o tipo Consulta" optionValue='code' className="w-full md:w-14rem" />
            </Panel>
          )}
          <br></br>
          {selectedTipoConsulta === 'pf' && resposta == null && (
            <FiltroPF msgs={msgs} onProcess={handleProcessFilter} onClose={handleCloseFilter}></FiltroPF>
          )}

          {selectedTipoConsulta === 'pj' && resposta == null && (
            <FiltroPJ msgs={msgs} onProcess={handleProcessFilter}  onClose={handleCloseFilter}></FiltroPJ>
          )}
          
         
         
        </div>
      </div>
      <div>
        {resposta != null && (
              <Resposta original={original} resposta={resposta} onClose={handleCloseFilter}></Resposta>
            )}
      </div>       
           
                
    </Container>
  )
}
